import { CallbackObject } from 'api/core/get-page-function';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const deleteTeam = async (teamId: string, callback: CallbackObject<any>) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res: AxiosResponse = await instance.delete(`/management/teams/${teamId}`, config);
        callback.success(res.data);
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
